import { mountInertia } from "@/lib/mount"

// THE MARKETING SITE (routes/(web)): the same Inertia app with no copilot, so
// an anonymous visitor to "/" does not download a chat they cannot open. That
// is the entire reason this entry exists -- the provider has to sit above every
// page for a page to register tools, so the only way to keep it off the
// marketing pages is to keep it out of their bundle.
//
// routes/(web)/_layout.rb is what points at this, by overriding `entrypoint`.
mountInertia()
